import axios from 'axios'
import * as actions from '../../actionTypes'

const GET_STATE_PROVINCE_LIST = 'GET_STATE_PROVINCE_LIST'
const GET_PROVINCE_LIST_SUCCESS = 'GET_PROVINCE_LIST_SUCCESS'
const GET_STATE_LIST_SUCCESS = 'GET_STATE_LIST_SUCCESS'
const GET_STATE_PROVINCE_LIST_FAILURE = 'GET_STATE_PROVINCE_LIST_FAILURE'
const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS'

const baseURL = process.env.REACT_APP_SERVICE_URL
const timeout = process.env.REACT_APP_AXIOS_TIME_OUT

const initialState = {
    provinces: [],
    states: [],
    countries: []
}

const instance = axios.create({
    timeout: parseInt(timeout),
})

// Reducer

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_PROVINCE_LIST_SUCCESS:
            return {
                ...state,
                provinces: action.payload,
            }
        case GET_STATE_LIST_SUCCESS:
            return {
                ...state,
                states: action.payload
            }
        case GET_COUNTRY_LIST_SUCCESS:
            return {
                ...state,
                countries: action.payload
            }
        case GET_STATE_PROVINCE_LIST:
        case GET_STATE_PROVINCE_LIST_FAILURE: {
            return initialState
        }
        case actions.CLEAR_ALL: {
            return initialState
        }
        default:
            return state
    }
}

export const getProvinceListAction = () => {
    return async (dispatch) => {
        dispatch({ type: GET_STATE_PROVINCE_LIST })
        const response = await instance.get(`${baseURL}services/payadebtservice/api/provinceList`)
        if (response.data && response.status === 200) {
            const { data } = response;
            dispatch({
                type: GET_PROVINCE_LIST_SUCCESS,
                payload: data,
            })
        } else {
            dispatch({ type: GET_STATE_PROVINCE_LIST_FAILURE })
            throw new Error(`Error in getting state province list`)
        }
    }
}

export const getStateListAction = () => {
    return async (dispatch) => {
        dispatch({ type: GET_STATE_PROVINCE_LIST })
        const response = await instance.get(`${baseURL}services/payadebtservice/api/stateList`)
        if (response.data && response.status === 200) {
            const { data } = response;
            dispatch({
                type: GET_STATE_LIST_SUCCESS,
                payload: data,
            })
        } else {
            dispatch({ type: GET_STATE_PROVINCE_LIST_FAILURE })
            throw new Error(`Error in getting state province list`)
        }
    }
}

export const getCountryListAction = () => {
    return async (dispatch) => {
        dispatch({ type: GET_STATE_PROVINCE_LIST })
        const response = await instance.get(`${baseURL}services/payadebtservice/api/countryList`)
        if (response.data && response.status === 200) {
            const { data } = response;
            dispatch({
                type: GET_COUNTRY_LIST_SUCCESS,
                payload: data,
            })
        } else {
            dispatch({ type: GET_STATE_PROVINCE_LIST_FAILURE })
            throw new Error(`Error in getting state province list`)
        }
    }
}

export const reduceTerritoryMap = (territories, language) => {
    return territories.reduce((territoryMap, currentTerritory) => {
        territoryMap[currentTerritory.value] = language === "en" ? currentTerritory.name : currentTerritory.nameFr
        return territoryMap
    }, {})
}

export const findProvinceOrState = (provincesOrStates, value) => {
    return provincesOrStates.find((territory) => territory.value === value)
}